<style lang="scss" scoped>
.slide-3 {
  background-image: url("../../../assets/module1/slide3/background-01.jpg");
  background-position: center;
  background-size: cover;
  padding-top: 100px;
  padding-left: 80px;
  padding-right: 80px;
  height: calc(100% - 100px);
}
p {
  color: white;
  margin-bottom: 15px;
}
h1 {
  font-size: 78px;
  line-height: 96px;
  transform-origin: 0% 50%;
  transform: rotate(-2deg);
}
h2 {
  margin-top: -20px;
}
h2,
h3 {
  color: #301e48;
  font-size: 46px;
  line-height: 55px;
}
h3 {
  color: #f8dc61;
}
h3 span {
  font-size: 80px;
}
.intro {
  margin-bottom: 40px;
}
.content {
  max-width: 556px;
  margin-left: auto;
  margin-right: 60px;
  margin-top: 20px;
  h3 {
    text-align: right;
    margin-top: 46px;
    font-size: 38px;
  }
}
</style>

<template>
  <div class="slide-3">
    <transition name="fadeLeft" appear>
      <img
        v-show="slideIndex == 2"
        src="@/assets/module1/slide3/characters-01.png"
        class="chars delay-6"
      />
    </transition>
    <transition name="fadeUp" appear>
      <p v-show="slideIndex == 2" class="intro delay-1">
        {{ $t("module1.slide3.intro") }}
      </p>
    </transition>
    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 2" class="delay-2">
        <h1>{{ $t("module1.slide3.heading") }}</h1>
      </div>
    </transition>
    <transition name="fadeUp" appear>
      <h2 v-show="slideIndex == 2" class="txtc delay-3">
        {{ $t("module1.slide3.heading2") }}
      </h2>
    </transition>
    <transition name="fadeUp" appear>
      <h3
        v-show="slideIndex == 2"
        v-html="$t('module1.slide3.heading3')"
        class="txtr big-span delay-4"
      ></h3>
    </transition>
    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 2" class="content delay-4">
        <p>{{ $t("module1.slide3.paragraph") }}</p>
        <h3 v-html="$t('module1.slide3.heading4')"></h3>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
